var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2TournamentPrizeLaurelLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 91.0532,
    height: 153.531,
    viewBox: "0 0 91.0532 153.531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M91.0532 146.161C89.4841 144.935 87.6738 144.059 85.7423 143.59L86.088 143.617C85.111 142.988 84.209 142.247 83.3996 141.411C79.164 137.108 78.8074 133.914 78.7964 133.914C80.3618 137.339 82.7763 140.302 85.8082 142.52C85.8082 142.52 85.0346 135.938 82.6315 132.336C81.298 130.277 79.7433 128.371 77.9954 126.654C71.8012 134.835 78.2094 141.411 83.7068 143.165C77.2767 142.156 69.25 144.18 66.2159 153.52C69.6113 153.591 73.0055 153.327 76.3495 152.731C82.3078 151.738 89.7365 146.85 89.6981 146.856C84.6855 146.231 79.5979 146.688 74.7749 148.196C74.7749 148.196 78.5166 145.901 86.5214 145.807C88.0399 145.773 89.5582 145.891 91.0532 146.161Z",
    fill: "url(#paint0_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.6662 142.85C60.6662 142.85 64.0679 140.191 71.8038 139.325C73.2712 139.146 74.7532 139.12 76.2259 139.248C74.5948 138.168 72.7484 137.46 70.8162 137.174H71.1564C70.1411 136.632 69.1912 135.975 68.3254 135.215C63.7716 131.304 63.1187 128.143 63.1077 128.143C64.9503 131.411 67.5947 134.15 70.7888 136.098C70.7888 136.098 69.3568 129.555 66.6959 126.168C65.2154 124.243 63.5302 122.485 61.6703 120.928C56.3868 129.754 63.3162 135.717 68.8301 136.926C62.4878 136.534 54.878 139.347 52.9193 148.968C56.2326 148.734 59.5138 148.163 62.7127 147.264C68.4022 145.713 75.0463 140.092 75.0134 140.092C70.0874 139.939 65.1886 140.881 60.6662 142.85Z",
    fill: "url(#paint1_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.7019 136.678C45.7019 136.678 49.6467 134.565 57.4265 134.841C58.8919 134.873 60.3499 135.058 61.7773 135.392C60.413 134.1 58.77 133.143 56.9767 132.595L57.3168 132.64C56.4575 131.967 55.6852 131.188 55.018 130.323C51.5121 125.854 51.6054 122.666 51.5944 122.666C52.6111 126.094 54.5608 129.169 57.2235 131.542C57.2235 131.542 57.3936 124.977 55.5776 121.281C54.5717 119.187 53.3251 117.219 51.8633 115.417C44.7692 123.25 50.0253 130.085 55.1112 132.082C49.0267 130.786 40.9726 132.43 36.7041 141.582C40.0115 141.804 43.3327 141.693 46.6182 141.251C52.5326 140.534 60.4496 136.021 60.4112 136.027C55.5194 135.165 50.4995 135.387 45.7019 136.678Z",
    fill: "url(#paint2_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.8103 128.468C32.8103 128.468 37.0788 126.962 44.5404 128.369C45.9434 128.614 47.3157 129.012 48.6333 129.555C47.6006 128.091 46.2225 126.908 44.6227 126.113L44.9574 126.212C44.2809 125.423 43.7143 124.545 43.2731 123.602C40.9248 118.709 41.7259 115.592 41.7149 115.592C41.8845 119.033 43.0623 122.345 45.1 125.114C45.1 125.114 46.7954 118.72 45.8297 114.826C45.3216 112.635 44.5419 110.516 43.509 108.52C34.9994 115.14 38.4559 122.615 42.9 125.324C37.3312 123.161 29.2222 123.575 22.984 131.988C26.1187 132.692 29.3186 133.062 32.5305 133.091C38.3736 133.229 47.141 129.958 47.1026 129.963C42.5087 128.401 37.6257 127.89 32.8103 128.468Z",
    fill: "url(#paint3_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.7235 122.07C31.6309 119.838 27.0727 118.608 22.4188 118.478C22.4188 118.478 26.808 117.634 33.6277 120.133C34.9096 120.58 36.1358 121.174 37.2817 121.904C36.6198 120.327 35.5586 118.952 34.2038 117.916C34.308 117.971 34.4123 118.026 34.5165 118.07C34.0417 117.187 33.6961 116.239 33.4905 115.257C32.3384 110.082 33.7648 107.131 33.7539 107.131C33.1546 110.468 33.5557 113.909 34.906 117.016C34.906 117.016 37.962 110.987 37.8578 107.021C37.8432 104.803 37.5426 102.596 36.9635 100.456C27.4828 105.614 29.1123 113.569 32.7553 116.901C27.9217 113.927 20.109 113.1 12.3292 120.519C15.1492 121.69 18.0952 122.527 21.1075 123.013C26.5885 123.989 35.7564 122.064 35.7235 122.07Z",
    fill: "url(#paint4_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.6267 112.598C23.2248 109.776 19.1726 107.858 14.8418 107.021C14.8418 107.021 19.1322 106.855 25.0631 110.364C26.1813 111 27.217 111.772 28.1465 112.664C27.8728 111.03 27.1572 109.503 26.0781 108.251L26.3579 108.46C26.0974 107.505 25.9736 106.516 25.9903 105.526C25.9903 100.23 27.9435 97.5376 27.938 97.5376C26.6877 100.689 26.3473 104.13 26.9559 107.467C26.9559 107.467 31.1641 101.989 31.8938 98.0617C32.3338 95.8847 32.4888 93.6593 32.3546 91.4419C22.3473 95.0166 22.2376 103.192 24.9808 107.037C21.0525 103.341 13.8378 101.283 4.99356 107.495C7.36152 109.093 9.92718 110.373 12.6252 111.301C17.5247 113.116 26.6487 112.598 26.6267 112.598Z",
    fill: "url(#paint5_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.0628 101.829C17.4779 98.5302 14.0707 95.9779 10.1871 94.4316C10.1871 94.4316 14.2087 94.9557 19.0643 99.3689C19.991 100.176 20.8065 101.103 21.4893 102.127C21.5816 100.494 21.2267 98.8663 20.4633 97.4216C20.5346 97.5154 20.6114 97.6036 20.6883 97.6864C20.6408 96.6881 20.7275 95.6879 20.9461 94.713C22.0434 89.4667 24.3642 87.1057 24.3642 87.1112C22.5694 90.0311 21.5668 93.3729 21.4564 96.8037C21.4564 96.8037 26.5478 92.0485 27.9743 88.2807C28.8093 86.2045 29.3789 84.0302 29.6696 81.8098C19.5416 83.6854 17.8682 91.8444 19.6733 96.0866C16.738 91.7782 10.3792 88.551 0.947896 93.3614C2.78892 95.3229 4.90088 97.0079 7.21894 98.3649C11.3832 100.925 20.0738 101.835 20.0628 101.829Z",
    fill: "url(#paint6_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.8281 84.5574C8.16937 87.8121 16.1028 90.0739 16.0973 90.0739C14.3659 86.4307 11.6873 83.3257 8.34494 81.0875C8.34494 81.0875 11.966 82.279 15.642 87.4646C16.3533 88.4296 16.9345 89.4851 17.3702 90.6035C17.7822 89.0074 17.7633 87.3297 17.3153 85.7434C17.3702 85.8482 17.4196 85.953 17.4799 86.0523C17.6257 85.0584 17.891 84.0858 18.27 83.1562C20.278 78.1085 22.8896 76.1612 22.8896 76.1612C20.6641 78.8035 19.1057 81.9468 18.3468 85.3242C18.3468 85.3242 24.0363 81.424 26.0718 77.932C27.2393 76.0134 28.161 73.9542 28.815 71.8032C18.9393 71.919 15.9218 79.8297 16.8106 84.3477C14.9068 79.5539 9.56842 75.2455 0 78.5002C1.29629 80.7526 2.92408 82.7947 4.8281 84.5574Z",
    fill: "url(#paint7_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.6536 77.7545C13.7379 73.8873 11.8247 70.331 9.10674 67.4441C9.10674 67.4441 12.234 69.27 14.7139 75.0679C15.2005 76.1609 15.5453 77.3123 15.7399 78.4937C16.4302 76.9749 16.7211 75.3034 16.5848 73.6391C16.5848 73.7495 16.6452 73.8653 16.6781 73.9701C16.9978 73.0045 17.4267 72.0791 17.9564 71.2119C20.6997 66.5173 23.4813 65.0389 23.4868 65.0389C20.9279 67.3311 18.9285 70.1852 17.6437 73.3799C17.6437 73.3799 23.6788 70.4616 26.1752 67.3503C27.6052 65.6428 28.8196 63.7639 29.7908 61.7565C20.4638 60.1016 16.3599 67.5268 16.3983 72.1883C15.482 67.0634 11.2574 61.8007 1.9414 63.4005C2.70042 65.8559 3.80923 68.1879 5.23328 70.3237C7.71866 74.1466 14.6481 77.7545 14.6536 77.7545Z",
    fill: "url(#paint8_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.5244 65.1771C15.3398 61.1781 14.169 57.288 12.1173 53.8571C12.1173 53.8571 14.7069 56.2624 16.0347 62.5015C16.301 63.683 16.4244 64.8926 16.4023 66.1038C17.321 64.7008 17.8755 63.0887 18.0153 61.4148C18.0153 61.5251 18.0153 61.641 18.0153 61.7458C18.4711 60.8409 19.023 59.9882 19.6612 59.2027C22.997 55.0046 25.8006 54.0392 25.8116 54.0392C23.032 55.9149 20.7146 58.4034 19.0358 61.3155C19.0358 61.3155 25.1313 59.4675 27.9952 56.8361C29.6218 55.3863 31.063 53.739 32.2856 51.9319C23.7542 48.5447 18.8163 55.2694 18.0921 59.9364C18.0921 54.6405 14.9922 48.5833 6.22485 48.473C6.51962 51.0685 7.15423 53.6134 8.11219 56.0417C9.71973 60.3611 15.5244 65.1826 15.5244 65.1771Z",
    fill: "url(#paint9_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.3981 52.7426C18.8491 48.6906 18.357 44.5886 16.9607 40.7607C16.9607 40.7607 19.0126 43.6734 19.2869 50.1388C19.3508 51.3662 19.2753 52.597 19.062 53.8073C20.157 52.5609 20.9246 51.0589 21.295 49.4382C21.295 49.543 21.295 49.6478 21.2676 49.7526C21.8225 48.9363 22.4666 48.185 23.1878 47.5129C26.9186 43.9437 29.6838 43.5189 29.6948 43.5189C26.7778 44.89 24.229 46.9422 22.2606 49.5044C22.2606 49.5044 28.2244 48.7817 31.3188 46.702C33.07 45.5623 34.6687 44.2015 36.0756 42.6528C28.4603 37.6328 22.9519 43.4196 21.5913 47.9653C22.3758 42.6584 20.3623 36.0109 12.3411 34.1739C12.2471 36.8557 12.4588 39.5395 12.972 42.1729C13.795 46.862 18.3762 52.7536 18.3981 52.7426Z",
    fill: "url(#paint10_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.9334 40.8325C23.9339 36.8118 24.037 32.6182 23.2352 28.5527C23.2352 28.5527 24.7714 31.8626 24.124 38.4218C24.0143 39.6551 23.7696 40.8724 23.3943 42.0517C24.6067 41.0013 25.5321 39.6569 26.0826 38.146C26.0826 38.2342 26.0388 38.328 26.0223 38.4163C26.6464 37.7149 27.3498 37.0892 28.1181 36.5517C32.0903 33.7162 34.7568 33.8486 34.7677 33.8486C31.8266 34.6466 29.1432 36.2019 26.9824 38.3611C26.9824 38.3611 32.6609 38.7859 35.876 37.324C37.6911 36.5324 39.3909 35.4969 40.9291 34.2458C34.3453 27.7583 28.4693 32.4088 26.5764 36.6786C28.0139 31.5372 26.9824 24.5422 19.8116 21.0337C19.3941 23.7373 19.2471 26.4761 19.3727 29.2092C19.5098 34.0692 22.906 40.8435 22.9334 40.8325Z",
    fill: "url(#paint11_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M30.5363 17.625C30.5363 17.625 31.6007 21.2714 30.1797 27.6651C29.9272 28.8628 29.5426 30.0285 29.033 31.1405C30.3157 30.3324 31.3552 29.1881 32.0396 27.8306C32.0396 27.9078 31.9792 27.985 31.9573 28.0623C32.6254 27.4926 33.3629 27.0107 34.1519 26.628C38.2393 24.6089 40.7357 25.2985 40.7686 25.2985C37.9078 25.4758 35.1595 26.4837 32.8571 28.2002C32.8571 28.2002 38.1515 29.7559 41.405 28.9615C43.2301 28.5444 44.9856 27.8644 46.6172 26.9424C41.0374 19.2193 35.0188 22.5292 32.7035 26.3908C34.6567 21.5638 34.4921 14.3978 28.1881 9.37229C27.4992 12.0285 27.0565 14.7432 26.8658 17.4816C26.4324 22.3913 28.7313 29.8441 28.7532 29.8386C30.2295 25.9477 30.8382 21.7784 30.5363 17.625Z",
    fill: "url(#paint12_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M38.7149 8.71059C38.7149 8.71059 39.3678 12.5722 37.3048 18.6403C36.9364 19.7654 36.4412 20.8445 35.829 21.8565C37.1385 21.3089 38.256 20.3813 39.0386 19.192C39.0111 19.2527 38.9782 19.3189 38.9508 19.3851C39.6498 18.956 40.4077 18.6326 41.2003 18.4252C45.3151 17.2888 47.6798 18.5024 47.6853 18.5024C44.9946 18.0487 42.2301 18.472 39.7957 19.7105C39.7957 19.7105 44.6513 22.353 47.8883 22.2426C49.6823 22.2178 51.462 21.9183 53.1663 21.3545C48.5851 12.5997 42.5005 14.5471 39.8616 17.8791C42.2317 13.5045 42.8078 6.40469 37.2939 0C36.3988 2.52553 35.7233 5.12436 35.2749 7.76727C34.3806 12.5777 35.7028 20.4884 35.7193 20.4553C37.5837 16.8168 38.6077 12.8022 38.7149 8.71059Z",
    fill: "url(#paint13_linear_0_12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M43.6791 11.2708C46.1864 7.13889 48.4359 6.23417 48.4414 6.23417C46.1823 8.18456 44.4102 10.641 43.2676 13.4057C43.2676 13.4057 48.2054 11.679 50.4 9.10277C52.5946 6.52655 53.6096 2.65395 53.6151 2.65395C43.7394 2.80841 41.7698 9.39514 42.4611 13.8139C42.7777 12.9258 43.1859 12.0734 43.6791 11.2708Z",
    fill: "url(#paint14_linear_0_12)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_12",
    x1: 65.4614,
    y1: 140.115,
    x2: 91.795,
    y2: 140.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_12",
    x1: 52.2113,
    y1: 134.971,
    x2: 76.9219,
    y2: 134.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_12",
    x1: 35.9424,
    y1: 128.576,
    x2: 62.5261,
    y2: 128.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_12",
    x1: 22.2049,
    y1: 120.828,
    x2: 49.3993,
    y2: 120.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_12",
    x1: 11.5536,
    y1: 111.891,
    x2: 38.6228,
    y2: 111.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_12",
    x1: 4.16097,
    y1: 102.071,
    x2: 33.2199,
    y2: 102.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_12",
    x1: 0.0753974,
    y1: 91.9851,
    x2: 30.5274,
    y2: 91.9851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_12",
    x1: -0.875332,
    y1: 81.2187,
    x2: 29.6755,
    y2: 81.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_12",
    x1: 1.0954,
    y1: 70.021,
    x2: 30.6225,
    y2: 70.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_12",
    x1: 5.43318,
    y1: 57.3029,
    x2: 33.0639,
    y2: 57.3029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_12",
    x1: 11.5977,
    y1: 44.0067,
    x2: 36.785,
    y2: 44.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_12",
    x1: 18.6731,
    y1: 31.5599,
    x2: 41.5741,
    y2: 31.5599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_12",
    x1: 26.2098,
    y1: 20.2742,
    x2: 47.2087,
    y2: 20.2742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_12",
    x1: 34.4118,
    y1: 11.1412,
    x2: 53.7098,
    y2: 11.1412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_12",
    x1: 41.9935,
    y1: 8.24306,
    x2: 53.9519,
    y2: 8.24306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TournamentPrizeLaurelLeft);
export default __webpack_public_path__ + "static/media/v2_tournament_prize_laurel_left.1414f467bed519ca7514c05fd64d1708.svg";
export { ForwardRef as ReactComponent };